import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { OVERLAY_DATA, OverlayRef } from '@app-core/services/overlay';
import { CartItem } from '@app-model/cart';
import { ButtonComponent } from '@app-shared/components/button/button.component';
import { IconComponent } from '@app-shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent],
  styleUrls: ['./invalid-checkout-popup.component.scss'],
  templateUrl: './invalid-checkout-popup.component.html',
})
export class InvalidCheckoutPopupComponent {
  private data = inject<{
    invalidCart: CartItem[];
  }>(OVERLAY_DATA);
  private _ref = inject<OverlayRef<InvalidCheckoutPopupComponent>>(OverlayRef);

  invalidCart: CartItem[] = [];

  constructor() {
    this.invalidCart = this.data.invalidCart;
  }

  close(): void {
    this._ref.close();
  }
}
